<template>
  <div class="w-full lg:w-[32%] bg-[#1c4848] relative flex flex-col p-8 text-white shrink-0 overflow-hidden">
    <div
      v-if="backgroundImageUrl"
      class="absolute top-0 left-0 w-full h-full opacity-20 bg-cover bg-center mix-blend-overlay"
      :style="{ backgroundImage: `url(${backgroundImageUrl})` }"
    />
    <div class="absolute -top-20 -left-20 w-64 h-64 bg-[#ecd79f]/10 blur-[80px] rounded-full"></div>
    <div class="absolute -bottom-20 -right-20 w-80 h-80 bg-[#ecd79f]/20 blur-[100px] rounded-full"></div>

    <div class="relative z-10 flex flex-col h-full justify-between">
      <div class="flex items-center justify-between">
        <div class="flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/5 border border-white/10 backdrop-blur-md">
          <div class="w-1.5 h-1.5 rounded-full bg-[#ecd79f] animate-pulse"></div>
          <span class="text-[9px] font-bold text-white tracking-widest uppercase">Live Preview</span>
        </div>
        <button type="button" class="text-white/40 hover:text-white transition-colors p-1">
          <i class="pr pr-menu-dots text-xl block"></i>
        </button>
      </div>

      <div class="flex-1 flex flex-col items-center justify-center -mt-4">
        <div class="relative w-64 aspect-square group">
          <div class="absolute inset-4 bg-[#ecd79f] blur-[50px] opacity-20 group-hover:opacity-30 transition-opacity duration-500"></div>
          <div class="relative w-full h-full rounded-[32px] overflow-hidden shadow-2xl border border-white/10 bg-[#153838]">
            <img
              v-if="coverImageUrl"
              :src="coverImageUrl"
              alt="Cover"
              class="w-full h-full object-cover opacity-90 group-hover:scale-105 transition-transform duration-700 ease-out"
            />
            <div v-else class="w-full h-full flex items-center justify-center bg-[#153838]">
              <i class="pr pr-gallery text-4xl text-white/30 block"></i>
            </div>
            <div class="absolute inset-0 bg-gradient-to-tr from-white/10 to-transparent opacity-50 pointer-events-none"></div>
          </div>
          <div class="absolute -bottom-4 left-1/2 -translate-x-1/2 bg-[#1c4848] text-[#ecd79f] text-[10px] font-bold px-4 py-1.5 rounded-full border border-[#ecd79f]/20 shadow-xl uppercase tracking-wider flex items-center gap-1.5 z-20 whitespace-nowrap">
            <i class="pr pr-headphones text-sm block"></i>
            Draft Audio
          </div>
        </div>

        <div class="text-center mt-10 space-y-2 px-4">
          <h3 class="text-2xl font-serif text-[#f2f4f4] font-medium leading-tight">
            {{ title || 'New Podcast Title' }}
          </h3>
          <p class="text-xs font-semibold text-white/40 tracking-wide">
            {{ subtitle || 'Host Name • Season 1' }}
          </p>
        </div>
      </div>

      <div class="bg-[#153838]/40 backdrop-blur-xl rounded-[24px] p-5 border border-white/5 shadow-lg mt-4 relative">
        <div v-if="!audioUrl" class="absolute inset-0 rounded-[24px] bg-black/50 flex items-center justify-center z-10 backdrop-blur-sm">
          <p class="text-xs font-bold text-white/90 text-center px-4">Add audio in the form to preview</p>
        </div>
        <AudioPlayer :src="audioUrl" variant="dark" :bar-count="32" />
      </div>
    </div>
  </div>
</template>

<script setup>
import AudioPlayer from '@/components/audio/AudioPlayer.vue';

defineProps({
  backgroundImageUrl: { type: String, default: '' },
  coverImageUrl: { type: String, default: '' },
  title: { type: String, default: '' },
  subtitle: { type: String, default: '' },
  audioUrl: { type: String, default: '' },
});
</script>
